<template>
  <div>
    <div class="ans_title">
      <div>
        <header id="dheader_top" :class="[appversion == 'old'?'old_app':'']">
          <section class="dhead_back" @click="goBack" v-show="appversion == 'new'">
            <img class="img" src="~assets/images/w-back.png" alt />
            <span class="text">在线问答</span>
          </section>
          <section class="nick" @click="changeNick">修改昵称 ></section>
        </header>
      </div>
      <div class="title">{{topicDetailData.topicName}}</div>
      <div class="detail">{{topicDetailData.description}}</div>
      <div class="product" v-if="showPrice">
        <ul>
          <li
            v-for="(item,index) in product"
            :key="index"
            :class="[{'red':item.class == 'red'},{'green':item.class == 'green'}]"
          >
            <span style="margin-right:.2rem">{{item.name}} {{item.val}}</span>
            <!-- <span>{{item.val}}</span> -->
          </li>
        </ul>
      </div>
    </div>
    <div class="ans_detail" v-show="showContent">
      <div class="choiceDirection">
        <div class="text_area">
          <div class="left_text" @click="addAddNums">
            看涨
            <span class="hand"></span>
            <span>{{leftData}}</span>
          </div>
          <div class="right_text" @click="addSubNums">
            看跌
            <span class="hand hand_right"></span>
            <span>{{rightData}}</span>
          </div>
        </div>
        <div class="direction_detail">
          <div class="d_left direction" :style="{animation:'left 1.5s forwards'}">
            <span v-show="showLeft"></span>
          </div>
          <div class="d_right direction" :style="{animation:'right 1.5s forwards'}">
            <span v-show="showRight"></span>
          </div>
        </div>
      </div>
      <div class="ans_status">
        <div
          class="status"
          :class="[{'ing':topicDetailData.status == 1 },{'future':topicDetailData.status == 0},{'ever':topicDetailData.status == 2}]"
        >
          <i></i>
          <span>{{topicDetailData.status | filterText }}</span>
        </div>
        <div class="choice_part">
          <div
            class="left common"
            :class="[{'active':nactive == true}]"
            @click="getData('0',topicDetailData.id)"
          >最新</div>
          <div
            class="right common"
            :class="[{'active':hactive == true}]"
            @click="getData('1',topicDetailData.id)"
          >最热</div>
        </div>
      </div>

      <div class="ans_content">
        <question-party :chioceQuestionData="topicDataArr"></question-party>
        <div class="load_more" @click="loadMore('more')">点击加载更多</div>
      </div>
    </div>
    <div class="ans_never" v-show="!showContent">
      <img src="~assets/images/index/Empty.png" alt />
      <div class="text">
        期待您的参与
        <span>{{topicDetailData.startDate + '~'+ topicDetailData.endDate}}</span>
      </div>
    </div>
    <div class="ask_btn" v-show="topicDetailData.status == 1 " @click="ask(topicDetailData.id)">
      <span>问</span>
    </div>
  </div>
</template>

<script>
import { toast } from "assets/commonjs/toast";
import { getStore, setStore } from "assets/commonjs/storage";
import questionParty from "components/questionParty";
import appLogin from "assets/commonjs/app";
import user from "assets/commonjs/userInfo";
export default {
  data() {
    return {
      showContent: true,
      id: "",
      companyId: 1,
      topicDetailData: {},
      showPrice: false,
      topicDataArr: [],
      product: [],
      showPrice: false,
      showAskBtn: false,
      sortType: 0,
      nactive: true,
      hactive: false,
      pageNum: 0,
      pageSize: 6,
      imgUrl: require("../../assets/images/w-back.png"),
      appversion: "new",
      topicName: "",
      activeColor: "red",
      leftData: "",
      rightData: "",
      showLeft: false,
      showRight: false,
      askLable: false
    };
  },
  components: {
    questionParty
  },
  created() {
    //说明是旧版本或者是移动端
    if (
      getStore("liveappver") != "" &&
      getStore("liveappver") != undefined &&
      getStore("liveappver") != null
    ) {
      //肯定是新版
      this.appversion = "new";
    } else if (
      getStore("noneheader") == null ||
      getStore("noneheader") == "" ||
      getStore("noneheader") == undefined
    ) {
      //移动端

      this.appversion = "new";
    } else {
      this.appversion = "old";
    }
  },
  filters: {
    filterText(val) {
      if (val == 0) {
        return "未开始";
      } else if (val == 1) {
        return "进行中";
      } else {
        return "已结束";
      }
    }
  },
  methods: {
    changeNick() {
      if (
        getStore("userInfoAll") == undefined ||
        getStore("userInfoAll") == null ||
        getStore("userInfoAll") == ""
      ) {
        if (
          getStore("noneheader") == null ||
          getStore("noneheader") == "" ||
          getStore("noneheader") == undefined
        ) {
          this.$router.replace("/login");
        } else {
          // window.location.href = "intercept_login";
          window.location.replace("/intercept_login")
        }
      } else {
        this.$router.push("/changeNick");
      }
    },
    ask(id) {
      if (
        getStore("userInfoAll") == undefined ||
        getStore("userInfoAll") == null ||
        getStore("userInfoAll") == ""
      ) {
        if (
          getStore("noneheader") == null ||
          getStore("noneheader") == "" ||
          getStore("noneheader") == undefined
        ) {
          this.$router.replace("/login");
        } else {
          // app拦截登录
          // window.location.href = "intercept_login";
          window.location.replace("/intercept_login")
        }
      } else {
        this.$router.push({
          path: "/ask",
          query: {
            id: id,
            liveName: this.topicName
          }
        });
      }
    },
    getDetailData(id, type) {
      let data = {
        companyId: 1,
        id: id,
        pageSize: this.pageSize,
        sortType: this.sortType,
        pageNum: this.pageNum
      };
      this.$api.strageList.getTopicDetail(data).then(res => {
        if (res.data && res.data.code == 0) {
          if (res.data.result.status == 0) {
            this.showContent = false;
          } else {
            this.showContent = true;
          }
          if (type == "more") {
            if (res.data.result.ansQuestionVoList.length == 0) {
              toast("没有更多数据了");
            }
            this.topicDataArr = this.topicDataArr.concat(
              res.data.result.ansQuestionVoList
            );
          } else if (type == "sort") {
            this.topicDataArr = res.data.result.ansQuestionVoList;
          } else {
            this.topicDetailData = res.data.result;
            if (
              this.topicDetailData.totalAddNum == 0 ||
              this.topicDetailData.totalSubNum == 0
            ) {
              this.showLeft = false;
              this.showRight = false;
            } else {
              this.showLeft = true;
              this.showRight = true;
            }
            if (
              this.topicDetailData.totalAddNum == 0 &&
              this.topicDetailData.totalSubNum == 0
            ) {
              this.partern(
                this.topicDetailData.totalAddNum,
                this.topicDetailData.totalSubNum,
                "history"
              );
              this.showLeft = true;
              this.showRight = true;
            } else {
              this.partern(
                this.topicDetailData.totalAddNum,
                this.topicDetailData.totalSubNum
              );
            }

            this.topicName = this.topicDetailData.topicName;
            this.topicDataArr = res.data.result.ansQuestionVoList;
            let productCode = res.data.result.productCode;
            this.getProduceData(productCode);
          }
        }
      });
    },
    partern(leftData, rightData, type) {
      this.leftData = leftData;
      this.rightData = rightData;
      let total = leftData + rightData;
      let left,
        right = "";
      if (type == "history") {
        left = "50%";
        right = "50%";
      } else {
        left = parseInt((leftData / total) * 100) + "%";
        right = parseInt((rightData / total) * 100) + "%";
      }
      let style = document.createElement("style");
      style.setAttribute("type", "text/css");
      document.head.appendChild(style);
      let sheet = style.sheet;
      sheet.insertRule(
        `@-webkit-keyframes left{
               0% {
                  left: 0px;
                }
                100% {
                  left: 0px;
                  width: ${left};
                }
            }`
      );
      sheet.insertRule(
        `@-webkit-keyframes right{
               0% {
                  right: 0px;
                }
                100% {
                  right: 0px;
                  width: ${right};
                }
            }`
      );
    },
    getProduceData(code) {
      let productPramas = [];
      this.$api.strageList.getProductDataSingle(code).then(res => {
        let ampClass, ampValue, ampName, ampPrice;
        if (res.data) {
          let data = res.data.data;
          for (let i in data) {
            if (getStore("patternLabel") == "redGreen" || getStore('patternLabel') == undefined) {
              if (data[i].amplitude > 0) {
                ampClass = "red";
              } else {
                ampClass = "green";
              }
            } else {
              if (data[i].amplitude > 0) {
                ampClass = "green";
              } else {
                ampClass = "red";
              }
            }
            if (data[i].amplitude) {
              // ampClass = data[i].amplitude > 0 ? "red" : "green";
              ampValue = this.percent(data[i].amplitude);
            } else if (data[i].amplitude == 0) {
              ampClass = "";
              ampValue = 0;
            }
            if (data.length <= 10) {
              this.showPrice = true;
              // console.log('data[i].name' ,data[i].name);
              // console.log('data' ,data);
            } else {
              this.showPrice = false;
            }
            ampName = data[i].name;
            ampPrice = data[i].price;
            productPramas.push({
              class: ampClass,
              val: ampValue,
              name: ampName,
              price: ampPrice
            });
          }
        }
      });
      this.product = productPramas;
    },
    percent: function(value) {
      if (!value) return "";
      value = Number(value * 100).toFixed(2);
      value += "%";
      return value;
    },
    getData(type) {
      this.pageNum = 0;
      if (type == 0) {
        this.nactive = true;
        this.hactive = false;
      } else {
        this.nactive = false;
        this.hactive = true;
      }
      this.sortType = type;

      this.getDetailData(this.id, "sort");
    },
    loadMore(type) {
      this.pageNum += this.pageSize;
      this.getDetailData(this.id, type);
    },
    addAddNums() {
      let clickedAddId = getStore("optionAdd_" + this.id);
      let clickedSubId = getStore("optionSub_" + this.id);
      if (clickedAddId == this.id || clickedSubId == this.id) {
        toast("您已参与当前看涨/看跌，请前往其他问答参与！");
        return;
      }
      let data = {
        id: this.id,
        count: 1,
        companyId: this.companyId
      };
      this.$api.strageList.addAddNums(data).then(res => {
        if (res.data && res.data.code == 0) {
          if (this.rightData == 0) {
            this.showRight = false;
            this.showLeft = false;
          } else {
            this.showLeft = true;
            this.showRight = true;
          }
          this.partern(this.leftData + 1, this.rightData);
          setStore("optionAdd_" + this.id, this.id);
        }
      });
    },
    addSubNums() {
      let clickedAddId = getStore("optionAdd_" + this.id);
      let clickedSubId = getStore("optionSub_" + this.id);
      if (clickedAddId == this.id || clickedSubId == this.id) {
        toast("您已参与当前看涨/看跌，请前往其他问答参与！");
        return;
      }
      let data = {
        id: this.id,
        count: 1,
        companyId: this.companyId
      };
      this.$api.strageList.addSubNums(data).then(res => {
        if (res.data && res.data.code == 0) {
          if (this.leftData == 0) {
            this.showLeft = false;
            this.showRight = false;
          } else {
            this.showRight = true;
            this.showLeft = true;
          }
          this.partern(this.leftData, this.rightData + 1);
          setStore("optionSub_" + this.id, this.id);
        }
      });
    },
    goBack() {
      if (this.askLable) {
        this.$router.push("/questionAnswer");
      } else {
        this.$router.go(-1);
      }
    }
  },
  mounted() {
    this.pageNum = 0;
    this.id = this.$route.query.id;

    if (this.$route.query.label && this.$route.query.label == "askBack") {
      this.askLable = true;
    } else {
      this.askLable = false;
    }

    if (this.id) {
      this.getDetailData(this.id);
    }
  }
};
</script>

<style lang="scss" >
@import "~assets/styles/mixin";
#dheader_top {
  line-height: 0.8rem;
  @include fj();
  font-size: 0;

  .nick {
    @include sc(0.28rem, #fff);
  }
}
#dheader_top.old_app {
  display: unset;
}
#dheader_top.old_app .nick {
  text-align: right;
}
.dhead_back .img {
  @include wh(0.17rem, 0.3rem);
  position: relative;
  top: 0.05rem;
  margin-right: 0.2rem;
}
.dhead_back .text {
  @include sc(0.32rem, #fff);
  font-weight: bold;
}

.ans_title {
  background: url("~assets/images/index/bg.png") no-repeat;
  width: 100%;
  padding: 0 0.3rem 0.3rem;
  .title {
    @include sc(0.32rem, #fff);
  }
  .detail {
    @include sc(0.26rem, #fff);
    margin: 0.3rem 0 0.4rem;
    word-wrap: break-word;
    word-break: break-all;
    overflow: hidden;
  }
  .product {
    width: 100%;
    ul {
      display: flex;
      align-items: center;
      overflow-x: scroll;
      overflow-y: hidden;
      li {
        @include wh(auto, 0.42rem);
        background: #fff;
        line-height: 0.42rem;
        border-radius: 0.06rem;
        text-align: center;
        font-size: 0;
        padding: 0 0.2rem;
        margin-right: 0.3rem;
        width: auto;
        span {
          @include sc(0.24rem, #ddd);
        }
      }
      li.red {
        span {
          color: #fb605a;
          white-space: nowrap;
        }
      }
      li.green {
        span {
          color: #51b64c;
          white-space: nowrap;
        }
      }
    }
  }
}
.ans_detail {
  padding: 0.5rem 0.3rem 0.4rem;
  .ans_status {
    @include fj();
    margin-bottom: 0.35rem;
    .status {
      border-radius: 0.06rem;
      font-size: 0;
      padding: 0.11rem 0.08rem;
      span {
        @include sc(0.24rem, #fff);
        vertical-align: middle;
        margin-left: 0.1rem;
      }
      i {
        display: inline-block;
        vertical-align: middle;
        @include wh(0.32rem, 0.32rem);
        @include bis("~assets/images/icon-sprite.png", 3.34rem, 3.2rem);
      }
    }
    .status.ing {
      background: #e7a70c;
      i {
        @include bp(-1.1rem, -0.74rem);
      }
    }

    .status.ever {
      background: #999;
      i {
        @include bp(-1.1rem, -0.74rem);
      }
    }
    .choice_part {
      @include fj();
      background: #f0f1f5;
      border-radius: 0.25rem;
      padding: 0.05rem 0;
      .common {
        flex: 1;
        border-radius: 0.25rem;
        text-align: center;
        @include sc(0.24rem, #333);
        padding: 0.1rem 0.17rem 0.1rem 0.17rem;
      }
      .left.active {
        color: #0a95ff;
        background: #fff;
        padding-left: 0.17rem;
        padding-right: 0.17rem;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
      }
      .right.active {
        color: #0a95ff;
        background: #fff;
        padding-right: 0.17rem;
        padding-left: 0.17rem;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
      }
    }
  }
  .ans_content {
    ul {
      li {
        padding-bottom: 0.43rem;
        border-bottom: 0.025rem solid #ddd;
      }
    }
    .con_title {
      display: flex;
      justify-content: space-between;
      margin: 0.3rem 0 0.18rem;
      .left {
        @include sc(0.28rem, #333);
        width: 5.35rem;
      }
      .right {
        @include sc(0.24rem, #999);
      }
    }
    .con_per {
      font-size: 0;
      span.name {
        @include sc(0.24rem, #e7a70c);
        margin-right: 0.1rem;
      }
      span.time {
        @include sc(0.24rem, #999);
      }
    }
    .repeat_content {
      background: #f0f1f5;
      padding: 0.17rem 0.2rem;
      margin-top: 0.3rem;
      .repeat_title {
        @include sc(0.28rem, #333);
      }
      .repeat_per {
        font-size: 0;
        span.per {
          margin-top: 0.15rem;
          @include sc(0.24rem, #0a95ff);
        }
        span.time {
          @include sc(0.24rem, #999);
        }
      }
    }
  }
}
.ans_never {
  padding-top: 2rem;
  text-align: center;
  img {
    width: 2.47rem;
  }
  .text {
    margin-top: 0.3rem;
    @include sc(0.28rem, #666);
  }
  span {
    @include sc(0.24rem, #666);
    display: block;
  }
}
.ask_btn {
  background: url("~assets/images/index/ask.png") no-repeat;
  @include wh(1.25rem, 1.25rem);
  background-size: 1.25rem 1.25rem;
  position: fixed;
  right: 0.48rem;
  text-align: center;
  font-size: 0;
  padding-top: 0.4rem;
  bottom: 1rem;
  z-index: 1000;
  span {
    @include sc(0.28rem, #0a95ff);
  }
}
.load_more {
  @include sc(0.3rem, #999);
  text-align: center;
  margin-top: 0.5rem;
}
.ans_content::v-deep .VueStar__ground {
  height: 1rem;
}
.ans_content::v-deep .like .VueStar {
  top: -0.3rem;
}
.ans_content::v-deep .VueStar__decoration {
  top: -0.48rem;
}
.text_area {
  display: flex;
  justify-content: space-between;
  @include sc(0.3rem, #333);
  font-weight: bold;
  margin-bottom: 0.1rem;
  .left_text {
    color: #e35655;
  }
  .right_text {
    color: #4c8ffe;
  }
}
.hand {
  display: inline-block;
  background: url("~assets/images/litterhand1.png") no-repeat;
  width: 0.3rem;
  height: 0.27rem;
  background-size: 0.3rem 0.27rem;
  margin: 0 0.1rem;
}
.hand.hand_right {
  background: url("~assets/images/litterhand.png") no-repeat;
  background-size: 0.3rem 0.27rem;
}
.direction_detail {
  position: relative;
  height: 0.66rem;
  margin-bottom: 0.5rem;
  .direction {
    width: 0px;
    height: 0.66rem;
    font-size: 0.3rem;
    color: #fff;
    position: absolute;
    line-height: 0.66rem;
  }
  .d_left {
    background: #e35655;
    border-radius: 0.08rem;
    left: 0;
  }

  .d_right {
    text-align: right;
    background: #4c8ffe;
    transition-duration: 1.5s;
    border-radius: 0.08rem;
    right: 0;
  }
  .d_right span {
    width: 0.4rem;
    height: 0.66rem;
    background: #4c8ffe;
    position: absolute;
    left: -0.16rem;
    top: 0;
    z-index: 9;
    height: 0.66rem;
    -webkit-transform: skew(-30deg);
    -moz-transform: skew(-30deg);
    -o-transform: skew(-30deg);
    transform: skew(-30deg);
  }
  .d_left span {
    width: 0.4rem;
    height: 0.66rem;
    background: #e35655;
    position: absolute;
    right: -0.16rem;
    top: 0;
    z-index: 9;
    height: 0.66rem;
    -webkit-transform: skew(-30deg);
    -moz-transform: skew(-30deg);
    -o-transform: skew(-30deg);
    transform: skew(-30deg);
  }
}
.add_text {
  position: absolute;
  left: 0.5rem;
}
.add_text.right {
  right: 0.5rem;
}
</style>